function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';
const AppliedPending = props => /*#__PURE__*/React.createElement(Svg, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 221,
  height: 125,
  fill: "none"
}, props), /*#__PURE__*/React.createElement(G, {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement(Path, {
  stroke: "#545F71",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M29.083 88.708h44.933m-44.933 25.387h44.933m-44.933-12.687h44.933M3.679 124.349h185.359m-6.761-51.452v51.452m-46.536-52.103v52.103m-42.418-57.92h51.851M20.589 124.35V77.972H82.51v46.377m13.093-56.006v56.006M9.046 68.343v56.006m50.509-81.446h71.796l23.789 17.294m33.924 17.216L159.27 57.607l-32.544 20.378m-23.684-4.36L52.351 37.673.878 74.446m123.764 50.125V90.647h-17.718v33.924m62.169-23.332h-20.167V80.965h20.167v20.274Z"
}), /*#__PURE__*/React.createElement(Path, {
  fill: "#EBF1FF",
  stroke: "#111C2B",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  d: "M167.829 103.919c28.37 0 51.368-22.971 51.368-51.309 0-28.337-22.998-51.309-51.368-51.309s-51.369 22.972-51.369 51.31c0 28.337 22.999 51.308 51.369 51.308Z"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#111C2B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M189.064 64.647v7.092L177.352 84.01h-36.269V23.54h47.981v7.378"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#111C2B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M189.064 70.906h-12.22V84.01M161.562 33.95h-11.803v14.783h11.803V33.95ZM167.386 33.95h9.731M167.386 41.341h5.432M167.386 48.733h5.055M149.759 56.124h24.205M149.759 63.515h30.784M149.759 70.906h18.786M188.464 58.323c6.174 0 11.178-4.999 11.178-11.165 0-6.166-5.004-11.165-11.178-11.165-6.173 0-11.177 4.999-11.177 11.165 0 6.166 5.004 11.165 11.177 11.165Z"
}), /*#__PURE__*/React.createElement(Path, {
  stroke: "#111C2B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m198.561 52.91 9.067 9.057a2.863 2.863 0 0 1 0 4.033l-.182.183a2.873 2.873 0 0 1-4.039 0l-9.067-9.057"
})), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
  id: "a"
}, /*#__PURE__*/React.createElement(Path, {
  fill: "#fff",
  d: "M.5 0h220v125H.5z"
}))));
export default AppliedPending;
//# sourceMappingURL=AppliedPending.js.map